import { isNil } from 'ramda';
import { EventOptionsFormData } from '~admin/view/components/details/event-details/event-options-details.component';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { ExternalNotificationSubscriptionTranslationRequestItem } from '~client/model/admin/external-notification-subscription-translation-request-item';
import { ExternalNotificationSubscriptionRequest } from '~client/model/admin/external-notification-subscription-request';
import { TranslationFormData } from '~admin/view/components/ui/form/fields/field-translation.component';
import { Language } from '~common/i18n';
import {
  arrayTranslations,
  isNilOrEmptyTranslationString,
  mergeTranslations,
} from '~admin/view/components/create-event/helper/merge-translations.helper';

const buildNotificationSubscriptionsRequest = (
  externalNotificationSubscriptionsId: number,
  externalNotificationSubscriptionsText: TranslationFormData<string>[],
): ExternalNotificationSubscriptionRequest[] => {
  if (isNilOrEmptyTranslationString(externalNotificationSubscriptionsText)) {
    return null;
  }

  const notificationSubscriptionTranslations = new Map<
    Language,
    ExternalNotificationSubscriptionTranslationRequestItem
  >();
  mergeTranslations(
    notificationSubscriptionTranslations,
    'displayString',
    externalNotificationSubscriptionsText,
  );
  return [
    {
      id: externalNotificationSubscriptionsId,
      displayString: externalNotificationSubscriptionsText[0].value,
      translations: arrayTranslations(notificationSubscriptionTranslations),
    },
  ];
};

/**
 * Transforms EventOptionsFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventOptionDetailsRequest = (
  values: EventOptionsFormData,
): Pick<
  EventProfileCreateRequest,
  | 'ticketLimit'
  | 'currency'
  | 'private'
  | 'vanityName'
  | 'liveStreamReplaySeconds'
  | 'externalNotificationSubscriptions'
  | 'facebookPixelId'
> => {
  const {
    ticketLimit,
    currency,
    isPrivateEvent,
    vanityName,
    liveStreamReplay,
    externalNotificationSubscriptionsId,
    externalNotificationSubscriptionsText,
    facebookPixelId,
  } = values;

  return {
    ticketLimit,
    currency,
    private: isPrivateEvent,
    liveStreamReplaySeconds: !isNil(liveStreamReplay) ? liveStreamReplay * 60 : null,
    vanityName,
    facebookPixelId,
    externalNotificationSubscriptions: buildNotificationSubscriptionsRequest(
      externalNotificationSubscriptionsId,
      externalNotificationSubscriptionsText,
    ),
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-option-details-request.helper.ts